import { GenericElement } from "../Elements/GenericElement";
import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";
import { FiltersWidget } from "../FiltersWidget";
import { checkAndDestroySelect2, globalMatcher, globalTemplateResult } from "../Tools/GlobalMethods";
import { Options } from "select2";
declare var PlanManager: any;
declare var Savane: any;

export class KitchenTypeFilter implements IFilter {

    id: string;
    name?: string | null;
    type: string;
    kitchenElements: GenericElement[] = [];
    parentGroup: FilterGroup;
    controller: FiltersController;

    constructor(kitchenElements: GenericElement[], parentGroup: FilterGroup) {
        this.id = 'kitchenType';
        this.name = 'Style de cuisine/objet';
        this.type = 'kitchenType';

        this.controller = new FiltersController();
        this.kitchenElements = kitchenElements;
        this.parentGroup = parentGroup;
    }

    static getLinearPrice(arr: any) {
        if (!arr.objectTypeConfig) {
            return (0);
        }
        switch (arr.objectTypeConfig.doorType) {
            case "IX_frame_delia":
            case "IX_frame_suede":
                return (1150);
            default:
                return (1000);
        }
    }

    static getEntireKitchenPrice() {
        if (typeof PlanManager === 'undefined') return;
        FilterGroup.kitchenPrice = 0;

        let kitchenArrangements = PlanManager.getInstance().world.kitchenArrangementObjects;
        let linearBottom = 0;
        let linearTop = 0;
        let linearPrice = 0;

        for (let i = 0; i < kitchenArrangements.length; i++) {
            let arr = kitchenArrangements[i];

            linearPrice = KitchenTypeFilter.getLinearPrice(arr);

            // Is it Ixina manufacturer ?
            if (arr.manufacturer && arr.manufacturer._id === "662bb10916eb511a1c89d3ff") {
                switch (arr.objectType) {
                    case Savane.SceneConstants.ArrangementType.kitchenFurnitureBottom:
                        linearBottom += arr.length;
                        FilterGroup.kitchenPrice += arr.length * linearPrice / 1000;
                        break;

                    case Savane.SceneConstants.ArrangementType.kitchenFurnitureTop:
                        linearTop += arr.length;
                        break;

                    case Savane.SceneConstants.ArrangementType.kitchenFurnitureColumn:
                        FilterGroup.kitchenPrice += arr.length * linearPrice / 1000;
                        break;
                }

                if (arr.objectTypeConfig) {
                    if (arr.objectTypeConfig.isUnderSink) {
                        FilterGroup.kitchenPrice += 350;
                    }
                    if (arr.objectTypeConfig.builtinOven) {
                        FilterGroup.kitchenPrice += 350;
                    }
                    if (arr.objectTypeConfig.builtinDishwasher) {
                        FilterGroup.kitchenPrice += 350;
                    }
                    if (arr.objectTypeConfig.builtinFridge) {
                        FilterGroup.kitchenPrice += 350;
                    }
                    if (arr.objectTypeConfig.builtinMicrowave) {
                        FilterGroup.kitchenPrice += 350;
                    }
                    if (arr.objectTypeConfig.builtinDryer) {
                        FilterGroup.kitchenPrice += 350;
                    }
                    if (arr.objectTypeConfig.builtinWashingmachine) {
                        FilterGroup.kitchenPrice += 350;
                    }
                    if (arr.objectTypeConfig.builtinHood === "VRAI") {
                        FilterGroup.kitchenPrice += 350;
                    }
                }
            }
        }

        if (linearTop > linearBottom) {
            FilterGroup.kitchenPrice += (linearTop - linearBottom) * (linearPrice * 30 / 100) / 1000;
        }

        // Delivery price and cooking
        if (FilterGroup.kitchenPrice !== 0) {
            FilterGroup.kitchenPrice += (1500 + 350);
        }

        $('#kitchenPrice').text(KitchenTypeFilter.getKitchenPrice());
    };

    static getKitchenPrice() {
        if (FilterGroup.kitchenPrice === null) {
            KitchenTypeFilter.getEntireKitchenPrice();
        }
        return ('' + Math.floor(FilterGroup.kitchenPrice));
    }

    html(): string {
        let html = `
        <div class="filter" style="display: flex;flex-direction: column;align-items: center;margin:0 auto;max-width: 380px;width: 100%;">
            <div style="height:30px;font-weight:600;">
                Budget estimatif cuisine Ixina : <span id="kitchenPrice">${KitchenTypeFilter.getKitchenPrice()}</span>€
            </div>
            <div style="height:30px;">
                (Livraison, pose et électroménager inclus)
            </div>
            <span>${this.name}</span>
            <select id="kitchenTypeInput" style="width: 100%;" title="${this.name}"></select>
        </div>
        `;
        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            checkAndDestroySelect2('kitchenTypeInput');
            const data = this.kitchenElements.map((element) => {
                let selected = false;
                if (FilterGroup.filters.kitchenElement !== undefined) {
                    selected = element.name === FilterGroup.filters.kitchenElement.name;
                } else selected = element.name === FiltersWidget.newKitchenStyle.name;

                return {
                    id: element.id || '-1',
                    text: element.name,
                    title: this.name,
                    selected: selected,
                };
            });

            $('#kitchenTypeInput').select2({
                placeholder: {
                    id: '-2',
                    text: 'Choisissez un type d\'objet de cuisine'
                },
                data: [
                    {
                        id: '-2',
                        text: 'Choisissez un type d\'objet de cuisine',
                    },
                    ...data
                ],
                width: 'element',
                selectionCssClass: 'select-control',
                matcher: globalMatcher,
                templateResult: globalTemplateResult,
            } as Options);

            $('#kitchenTypeInput').on('change.select2', () => {
                let selectedValue = $('#kitchenTypeInput').val() as string;
                if (selectedValue === '-1') {
                    FilterGroup.filters.kitchenElement = null;
                }
                else {
                    FilterGroup.filters.kitchenElement = this.kitchenElements.find((element) => selectedValue === element.id) || null;
                }

                FiltersWidget.triggerDesignerFilterSelectionChanged();
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            });
        }, 50);
        return html;
    }

    destroy(): void {
        $('#kitchenTypeInput').off('change.select2');
        checkAndDestroySelect2('kitchenTypeInput');
        this.controller.destroy();
    }
}